import React, { useState, useRef, useMemo } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import CreateShelfModal from 'components/admin/shelf/CreateShelfModal';

import { adminShelfApi } from 'api';
import { useUserContext } from 'providers/UserProvider';

import {
  ADMIN_SHELF_LIST_TAB,
  getAdminShelfListColumns, // Import the new function
  ADMIN_SHELF_FILTER_OPTIONS,
} from 'constants/admin/shelf';

const Shelf = () => {
  const tableRef = useRef();
  const [showCreateShelfModal, setShowCreateShelfModal] = useState(false);
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(() => {
    return getAdminShelfListColumns(tenant, warehouse);
  }, [tenant, warehouse]);

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateShelfModal(true)}
    >
      Create Shelf
    </Button>
  );

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Shelf"
        apiService={adminShelfApi}
        sortable={true}
        columns={columns} // Use the memoized columns
        filterOptions={ADMIN_SHELF_FILTER_OPTIONS}
        tabOptions={ADMIN_SHELF_LIST_TAB}
        headerActions={headerActions}
      />

      <CreateShelfModal
        show={showCreateShelfModal}
        onHide={() => setShowCreateShelfModal(false)}
        onSuccess={handleActionSuccess}
      />
    </>
  );
};

export default Shelf;
